import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxOutlinedSvg from "@ant-design/icons-svg/es/asn/DropboxOutlined";
import AntdIcon from '../components/AntdIcon';
var DropboxOutlined = function DropboxOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DropboxOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DropboxOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DropboxOutlined';
}
export default RefIcon;